<app-map-layers-control [mapReady]="mapReady$" [layers]="layers"></app-map-layers-control>
<div id="history-map" class="history-map"
     leaflet
     [leafletOptions]="options"
     (leafletMapReady)="onMapReady($event)">
</div>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{of: host.nativeElement}"
  [visible]="isLoading"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
